export function InfoRowSkeleton() {
  return (
    <div className="flex min-h-[24.5px] animate-pulse items-center justify-between">
      <span className="h-4 w-24 rounded bg-light-gray-1" />
      <span className="h-4 w-32 rounded bg-light-gray-1" />
    </div>
  );
}
